// extracted by mini-css-extract-plugin
export default {"SpinnerLoaderGreen":"SpinnerLoaderGreen_SpinnerLoaderGreen__XVFk8","loading":"SpinnerLoaderGreen_loading__htxK+"};